<script>
    import {onDestroy, onMount} from 'svelte';
    import {PRConnect} from "@projectroom/ui-lib";
	import "./common/JWTWrapper.js";
    import {Router, navigateTo} from "svelte-router-spa";
    import {routes,} from "./routes";
    import ChannelService from "./views/util/ChannelTalk.js";
	import { initI18n } from './common/i18n.js';
    
    onMount( () => {
        // PRAppBase.init();
        ChannelService.boot({
            "pluginKey": "e0279b07-32ea-40e6-a0d9-39c08871ef1b", // fill your plugin key
        });
    }); 
  
    onDestroy(() => {  
    });  
    initI18n();
/*
    PRConnect.setProcessor({
        success: (response) => {
            console.log("interceptor : success @@ : ", response);
            return response;
        }, 
        error: (error) => {
            console.log("interceptor : error @@ : ", error);
            if( error.response.status === 401 ) {
                navigateTo("/login");
            }
            return error;
        } 
    }); 
    */
</script> 

<Router {routes} />

<style>
</style>